/**
 * Decision entity payload — a decision reached in one or more threads.
 *
 * `statement` is the canonical, extractor-normalized wording of the
 * decision; `rationale` and `scope` are optional context the extractor
 * may not always recover. `sourceThreadDecisionIds` links back to the
 * thread-local decision record(s) this entity was derived or reaffirmed
 * from.
 *
 * `authority` is a required literal today (I7): the extractor only ever
 * produces `'extracted'` decisions. Promotion to a union (e.g. adding a
 * human-`'confirmed'` variant) is a later additive change — do not model
 * it now.
 *
 * Design context: docs/plans/2026-05-26-llm-wiki-entities-prototype-design.md
 */

import { z } from 'zod';

export const decisionPayloadSchema = z.object({
  statement: z.string().min(1),
  rationale: z.string().optional(),
  scope: z.string().optional(),
  sourceThreadDecisionIds: z.array(z.string()),
  authority: z.literal('extracted'),
});

export type DecisionPayload = z.infer<typeof decisionPayloadSchema>;
